import type { IBlog_Data } from '@/components/content-app/interface/blog/IBlog'
import type { ICategory } from '@/components/content-app/interface/blog/IBlogCategory'
import { $contentAppAxios } from '@/utils/content-app/content-app-axios.util'
/**
 * Service that retrieves Blogs data
 */

/**
 *
 */
export default class BlogsService {
  /**
   * @returns array of categories
   */
  async getAllCategories(): Promise<ICategory[]> {
    return await $contentAppAxios
      .get(
        `/content/blog-categories?populate=thumbnail,darkThumbnail,blogs,blogs.banner,blogs.thumbnail,blogs.author&filters[$and][0][title][$ne]=Industry Updates`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   * @returns array of blogs
   */
  async getProductUpdatesRelatedBlogs(): Promise<IBlog_Data[]> {
    return await $contentAppAxios
      .get(
        `/content/blogs?sort[0]=id:desc&filters[$and][0][blog_category][title][$eq]=Product Updates`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   * @returns array of blogs
   */
  async getRecentlyAddedBlogs(): Promise<IBlog_Data[]> {
    return await $contentAppAxios
      .get(
        `/content/blogs?sort[0]=id:desc&populate=banner,thumbnail,blog_tags,author,author.thumbnail&filters[$and][0][blog_category][title][$ne]=category-updates`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   * @param param which is a string
   * @returns array of blogs
   */
  async getSearchedBlogsForAutocomplete(param: string): Promise<IBlog_Data[]> {
    return await $contentAppAxios
      .get(`/content/blogs?sort[0]=id:desc&_q=${param}`) //replace it with your search query
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   *
   * @param param which is string
   * @returns array of categories
   */
  async getSearchedBlogsCategory(param: string): Promise<ICategory[]> {
    return await $contentAppAxios
      .get(
        `/content/blog-categories?populate=thumbnail,blogs,blogs.banner&filters[$and][0][url][$eq]=${param}`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   *
   * @param param which is string
   * @returns array of blogs
   */
  async getSearchedBlog(param: string): Promise<IBlog_Data[]> {
    return await $contentAppAxios
      .get(
        `/content/blogs?populate=banner,author,blog_tags,author.thumbnail&filters[$and][0][url][$eq]=${param}`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }

  /**
   *
   * @param param which is string
   * @returns array of blogs
   */
  async getRelatedBlogs(param: string): Promise<IBlog_Data[]> {
    return await $contentAppAxios
      .get(
        `/content/blogs?populate=banner,author,blog_tags,author.thumbnail&filters[$and][0][blog_tags][name][$eq]=${param}`
      )
      .then((response) => {
        return response.data.data
      })
      .catch((err) => {
        throw err
      })
  }
}
